import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext);

export const DEFAULT_HERO_TITLE = "Quality Used Vehicles";
export const DEFAULT_HERO_SUBTITLE =
  "Great deals on dependable vehicles at 249 Route 170 in Oak Bay. Give us a call and experience how purchasing a vehicle should be!";

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data || {});
    } catch {
      setSettings({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ settings, refresh }), [settings, refresh]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};
